import { useReducer } from "react";
import { TestParams, TestState, UserCode } from "../../types/test-types";

export const SET_USER_CODE = "SET_USER_CODE";
export const setTesterName = (payload: string) =>
  <const>{
    type: SET_USER_CODE,
    payload: { userCode: payload },
  };

export const SET_TEST_INTERVAL = "SET_TEST_INTERVAL";
export const setTestInterval = (payload: string | number) =>
  <const>{
    type: SET_TEST_INTERVAL,
    payload,
  };

export const SET_TEST_PAUSE_DURATION = "SET_TEST_PAUSE_DURATION";
export const setTestPauseDuration = (payload: string | number) =>
  <const>{
    type: SET_TEST_PAUSE_DURATION,
    payload,
  };

export const SET_TEST_SOUND_RECORDING = "SET_TEST_SOUND_RECORDING";
export const setTestSoundRecording = (payload: boolean) =>
  <const>{
    type: SET_TEST_SOUND_RECORDING,
    payload,
  };

export const RESET_TEST_PARAMS = "RESET_TEST_PARAMS";
export const resetTestParams = () =>
  <const>{
    type: RESET_TEST_PARAMS,
    payload: initialState.testParams,
  };

export type Action = ReturnType<
  | typeof setTesterName
  | typeof setTestInterval
  | typeof setTestPauseDuration
  | typeof setTestSoundRecording
  | typeof resetTestParams
>;

export const initialState: TestState = {
  userCode: "",
  testParams: {
    testInterval: 4,
    testPauseDuration: 30,
    introductionSlideDuration: 3,
    testProcessSlideDuration: 15,
    questionsSlideDuration: 5,
    testSoundRecording: false,
  },
};

const setTestParam = (state: TestState, key: string, value: number | boolean | string) => ({
  ...state,
  testParams: {
    ...state.testParams,
    [key]: value,
  },
});

const setRootObject = (state: TestState, object: UserCode) => ({
  ...state,
  ...object,
});

const setRootObjectWithKey = (state: TestState, key: string, object: TestParams) => ({
  ...state,
  [key]: object,
});

export const reducer = (state: TestState, action: Action) => {
  switch (action.type) {
    case SET_USER_CODE:
      return setRootObject(state, action.payload);
    case SET_TEST_INTERVAL:
      return setTestParam(state, "testInterval", action.payload);
    case SET_TEST_PAUSE_DURATION:
      return setTestParam(state, "testPauseDuration", action.payload);
    case SET_TEST_SOUND_RECORDING:
      return setTestParam(state, "testSoundRecording", action.payload);
    case RESET_TEST_PARAMS:
      return setRootObjectWithKey(state, "testParams", action.payload);
    default:
      return state;
  }
};

export default function useTestReducer(state = initialState) {
  return useReducer(reducer, state);
}
